import { render } from "./NavbarAdmin.vue?vue&type=template&id=499f99d6"
import script from "./NavbarAdmin.vue?vue&type=script&lang=js"
export * from "./NavbarAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__